import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { FillingExperience } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/form');

export const FormPage: FC = () => {
  const {
    qwe = '',
    formId = '',
    packetId = '',
    companyId: locationId = '',
    secretCode = '',
    for_dependent,
    origin,
  } = routeApi.useSearch();
  const isKioskOrigin = origin === 'kiosk';

  // A valid link needs both a company id and a document id; otherwise the link is broken/incomplete
  if (!locationId) {
    return <FillingExperience.FormNotFound variant='link-broken' locationId={locationId} />;
  }

  // Solicited form/packet filling experience
  if (qwe) {
    return (
      <FillingExperience.Actual.SolicitedForm
        documentId={qwe}
        locationId={locationId}
        secretCode={secretCode}
        isDependent={String(for_dependent) === 'true'}
      />
    );
  }

  // Public form filling experience
  if (formId) {
    return (
      <FillingExperience.Actual.PublicForm documentId={formId} locationId={locationId} isKioskOrigin={isKioskOrigin} />
    );
  }

  // Public packet filling experience
  if (packetId) {
    return (
      <FillingExperience.Actual.PublicPacket
        documentId={packetId}
        locationId={locationId}
        isKioskOrigin={isKioskOrigin}
      />
    );
  }

  return <FillingExperience.FormNotFound variant='link-broken' locationId={locationId} />;
};
